import { initializeCursor } from '../shared/cursor.ts';
import { initializeNavigation, initializeScrollAnimations } from '../shared/navigation.ts';

// Initialize page
function initContactPage() {
  // Initialize cursor
  initializeCursor();

  // Initialize navigation
  initializeNavigation();

  // Initialize scroll animations
  initializeScrollAnimations();
}

// Wait for DOM to be ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initContactPage);
} else {
  initContactPage();
}
